<template>
  <div class="brand-selection-section">
    <h2 class="section-title"></h2>
    <div class="products-layout-container">
      <div class="products-scroll-viewport">
        <div class="products-grid">
          <ProductCard
            v-for="product in products"
            :key="product.id"
            @click="goToDetail(product.id)"
            :image-url="product.imageUrl"
            :name="product.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import frontServer from '../../../services/FrontManage'
import ProductCard from './ProductCard.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const goToDetail = (id) => {
  router.push({ name: 'ShoeDetail', params: { id } })
}

const products = ref([])

onMounted(async () => {
  try {
    const result = await frontServer.GetSubPicture();
    if (result && result.subGroup2Goods) {
      const baseConfig = result.subGroup2Goods;
      products.value = baseConfig.map(item => ({
        id: item.id || '',
        imageUrl: item.mainImage ? `${process.env.VUE_APP_BACKEND_BASE_URL}/${item.mainImage}` : 'https://via.placeholder.com/500?text=No+Image',
        // name: item.name || 'Product Name'
      }));
    } else {
      console.warn('subGroup2Goods not found in API response or result is invalid.');
      products.value = [];
    }
  } catch (error) {
    console.error('Failed to load subGroup2Goods:', error);
    products.value = [];
  }
});
</script>

<style scoped>
.brand-selection-section {
  padding: 80px 0;
  text-align: center;
  background-color: #fff;
  overflow: hidden;
}

.section-title {
  font-size: 40px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 30px;
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 3px solid #000000;
}

.products-layout-container {
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.products-scroll-viewport {
  width: 100%;
  overflow-x: auto; /* 允许水平滚动 */
  text-align: center;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,0.2) rgba(0,0,0,0.05);
}
.products-scroll-viewport::-webkit-scrollbar {
  height: 8px;
}
.products-scroll-viewport::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.05);
  border-radius: 4px;
}
.products-scroll-viewport::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 4px;
}

.products-grid {
  display: inline-flex;
  flex-wrap: nowrap;
  padding: 20px 0; /* 垂直内边距 */
  gap: 20px; /* 默认卡片间距，在移动端生效，或在桌面不使用 scale 时生效 */
}

/* 如果 clothing.vue 的桌面端不需要卡片缩放，则可以移除下面的 :deep() 规则 */
/* 如果需要缩放，则复制 brands.vue 中的 :deep(.product-card) 和对应的负 margin 规则 */
/* 例如，如果桌面端不缩放： */
.products-grid > :deep(.product-card) {
  /* 这里不需要 transform: scale 和负 margin */
  /* 间距由 .products-grid 的 gap 控制 */
}


/* 响应式调整 */
@media (max-width: 992px) {
  .section-title {
    font-size: 32px;
    margin-bottom: 25px;
  }
  .brand-selection-section {
    padding: 60px 0;
  }
  .products-grid {
    gap: 15px; /* 中等屏幕调整间距 */
  }
}

@media (max-width: 768px) {
  .products-layout-container {
    padding: 0 10px;
  }
  .section-title {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .products-grid {
    padding: 10px 0;
    gap: 10px; /* 移动端卡片间距 */
  }
  /* 在 clothing.vue 中，如果桌面端没有使用 scale，移动端也不需要特别处理 scale */
  /* ProductCard 自身的媒体查询会调整其大小 */
}

@media (max-width: 576px) {
  .section-title {
    font-size: 24px;
  }
  .brand-selection-section {
    padding: 40px 0;
  }
  .products-grid {
    gap: 8px; /* 更小屏幕的间距 */
  }
}
</style>